import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/opt/build/repo/node_modules/gatsby-theme-docz/src/base/Layout.js";
import { Container, Row, Col, Spacer, Callout } from '@cleartrip/bento/lib';
import IconList from '@components/IconList';
import Sandbox from '@components/Sandbox';
import { Activities } from '@cleartrip/bento-icons/src/components/Icons';
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">





    <h1 {...{
      "id": "bento-icons"
    }}>{`Bento icons`}</h1>
    <Callout variant="badge" mdxType="Callout"><span className="c-neutral-700 fs-3">Click to download the icon and copy the icon name</span></Callout>
    <h2 {...{
      "id": "installation"
    }}>{`Installation`}</h2>
    <Sandbox mdxType="Sandbox">
  <Sandbox.Text>
    $ yarn add @cleartrip/bento-icons
  </Sandbox.Text>
    </Sandbox>
    <h2 {...{
      "id": "usage"
    }}>{`Usage`}</h2>
    <Sandbox mdxType="Sandbox">
  <Sandbox.Text>
    import {'{ IconName }'} from '@cleartrip/bento-icons'
  </Sandbox.Text>
    </Sandbox>
    <h2 {...{
      "id": "icon-explorer"
    }}>{`Icon explorer`}</h2>
    <IconList mdxType="IconList" />

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      